import { RootState } from "../..";
import { UserAssetsData, UserPnLData, UserPnLExpectedData } from "./types";

export const selectUserAssetsData = (state: RootState):UserAssetsData => state.user.userAssets.userAssetsData;
export const selectUserAssetsDataLoading = (state: RootState):boolean => state.user.userAssets.loading;
export const selectUserPnLData = (state: RootState):UserPnLData => state.user.userAssets.userPnLData;
export const selectUserPnLDataLoading = (state: RootState):boolean => state.user.userAssets.userPnLloading;
export const selectUserPnLExpectedData = (state: RootState):UserPnLExpectedData[] => state.user.userAssets.userPnLExpectedData;
export const selectUserPnLExpectedDataLoading = (state: RootState):boolean => state.user.userAssets.userPnLloading;